const DEFAULT_MESSAGE = "Something went wrong.";

export function getMessage(e, fallback = DEFAULT_MESSAGE) {
  if (!e.response) {
    return e.message;
  }

  if (e.response.message) {
    return e.response.message;
  }

  if (e.response.data.message) {
    return e.response.data.message;
  }

  return fallback;
}

// A 422 from the v3 payment-session endpoints carries the useful detail in
// `errors` ({ field: [message] }); the sibling `message` is only Laravel's
// generic "The given data was invalid." Flattened here so an invalid promo code
// or an unknown session reaches the user.
function getValidationMessage(e) {
  const errors = e?.response?.data?.errors;

  if (!errors || typeof errors !== "object") {
    return "";
  }

  return Object.keys(errors)
    .reduce((messages, key) => messages.concat(errors[key]), [])
    .filter((message) => typeof message === "string" && !!message)
    .join(" ");
}

// For the payment paths only. Deliberately not folded into getMessage(): the
// global axios interceptor switches on that function's exact return value
// ("invalid_coupon", …), which an errors map would shadow.
export function getPaymentErrorMessage(e, fallback = DEFAULT_MESSAGE) {
  return getValidationMessage(e) || getMessage(e, fallback) || fallback;
}
